import { useFormikContext } from "formik";
import { ConfirmOptions, useConfirm } from "material-ui-confirm";

import { Button, makeStyles, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  margin: {
    marginLeft: theme.spacing(1)
  }
}));

export default function SaveButtons({
  handleSave,
  isSaving,
  isDisabled,
  variant = "saveAndContinue"
}: {
  handleSave: (opts: { goToNext: boolean }) => any;
  isSaving?: boolean;
  isDisabled?: boolean;
  variant: "saveAndContinue" | "continueOnly";
}): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.buttonContainer}>
      {isSaving ? <CircularProgress size={24} /> : null}
      <Button
        variant="contained"
        className={classes.margin}
        disabled={isSaving || isDisabled || variant === "continueOnly"}
        onClick={() => handleSave({ goToNext: false })}
      >
        Save
      </Button>
      <Button
        variant="contained"
        color="primary"
        className={classes.margin}
        disabled={isSaving}
        onClick={() => handleSave({ goToNext: true })}
      >
        {variant === "continueOnly" ? "Continue »" : "Save & Continue »"}
      </Button>
    </div>
  );
}

export function FormikSaveButtons({
  continueWithoutSaving,
  confirmSubmit,
  disabled
}: {
  continueWithoutSaving: () => any;
  confirmSubmit?: ConfirmOptions | null;
  disabled?: boolean;
}): JSX.Element {
  const formik = useFormikContext<{ goToNext?: boolean }>();
  const showConfirm = useConfirm();

  return (
    <SaveButtons
      handleSave={async ({ goToNext }) => {
        if (formik.dirty) {
          if (confirmSubmit) {
            try {
              await showConfirm(confirmSubmit);
            } catch {
              // user cancelled
              return;
            }
          }
          formik.setFieldValue("goToNext", goToNext);
          await formik.submitForm();
        } else {
          continueWithoutSaving();
        }
      }}
      isSaving={formik.isSubmitting}
      isDisabled={formik.isSubmitting || disabled}
      variant={formik.dirty ? "saveAndContinue" : "continueOnly"}
    />
  );
}
